import React, { Component } from 'react';

class ContactMessageSent extends Component {
	render() {
		return (
			<div className="col-md-12">
				<p>
					Thank you for contacting us, we will get back to you
					shortly.
				</p>
			</div>
		);
	}
}

export default ContactMessageSent;
